import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import AccessTimeOutlined from "@material-ui/icons/AccessTimeOutlined";
import AccountBalanceWalletOutlined from "@material-ui/icons/AccountBalanceWalletOutlined";
import HelpOutline from "@material-ui/icons/HelpOutline";
import DateRangeOutlined from "@material-ui/icons/DateRangeOutlined";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import grey from "@material-ui/core/colors/grey";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";

const styles = theme => ({
  card: {
    maxWidth: 240
  },
  media: {
    // ⚠️ object-fit is not supported by IE11.
    objectFit: "cover"
  },
  container: {
    padding: 20
  },
  textRight: {
    textAlign: "right"
  },
  helpButton: {
    width: 32,
    height: 32
  },
  flexCenter: {
    display: "flex",
    alignItems: "center"
  },
  duracion: {
    justifyContent: "flex-end",
    color: grey["600"],
    fontWeight: 500
  },
  time: {
    justifyContent: "flex-end"
  },
  iconDate: {
    fontSize: 24,
    marginRight: 5
  }
});

class ItemSummary extends React.PureComponent {
  render() {
    const {
      classes,
      showStudyNumber,
      showHelpButton,
      item,
      products,
      item: { project }
    } = this.props;

    return (
      <div>
        <div className={classes.container}>
          <Grid container spacing={8}>
            <Grid item xs={10}>
              <Typography variant="display1" color="textPrimary">
                <strong>
                  {item.project &&
                    item.project.project_type &&
                    item.project.project_type.name}
                </strong>
              </Typography>
            </Grid>

            {showHelpButton && (
              <Grid item xs={2} className={classes.textRight}>
                <IconButton className={classes.helpButton}>
                  <HelpOutline />
                </IconButton>
              </Grid>
            )}

            {showStudyNumber && (
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  paragraph
                  style={{ color: grey["500"] }}
                >
                  N&deg; estudio: {item.id}
                </Typography>
              </Grid>
            )}

            <Grid item xs={12}>
              <Typography className={classes.flexCenter} component="div">
                <DateRangeOutlined className={classes.iconDate} />
                <span style={{ color: grey["500"] }}>
                  Producto:
                </span> &nbsp;{" "}
                {Array.isArray(products) &&
                  products.map(product => (
                    <strong key={product.id}>{product.name} </strong>
                  ))}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {/*<Typography*/}
              {/*  className={classNames(classes.flexCenter, classes.duracion)}*/}
              {/*>*/}
              {/*  Duracion*/}
              {/*</Typography>*/}
            </Grid>
            <Grid item xs={10}>
              <Typography className={classes.flexCenter} component="div">
                <DateRangeOutlined className={classes.iconDate} />
                <span style={{ color: grey["500"] }}>Inicio:</span> &nbsp;{" "}
                <strong>
                  {Array.isArray(project.medical_visits) && project.medical_visits.length > 0 &&
                    project.medical_visits[0].date}
                </strong>
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                className={classNames(classes.flexCenter, classes.time)}
                component="div"
              >
                {/*<AccessTimeOutlined className={classes.iconDate} /> 3h*/}
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography className={classes.flexCenter} component="div">
                <DateRangeOutlined className={classes.iconDate} />
                <span style={{ color: grey["500"] }}>
                  Visita intermedia:
                </span>{" "}
              </Typography>
              <Paper className={classes.root}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell align="right">Start time</TableCell>
                      <TableCell align="right">End time</TableCell>
                      <TableCell align="right">Frequency</TableCell>
                      <TableCell align="right">Duration</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array.isArray(project.medical_visits) &&
                    project.medical_visits.slice(2).map(row => (
                        <TableRow key={row.id}>
                          <TableCell component="th" scope="row">
                            {row.date}
                          </TableCell>
                          <TableCell align="right">
                            {row.start_time}
                          </TableCell>
                          <TableCell align="right">{row.end_time}</TableCell>
                          <TableCell align="right">{row.frequency}</TableCell>
                          <TableCell align="right">{row.duration}</TableCell>
                        </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </Grid>
            <Grid item xs={2}>
              <Typography
                className={classNames(classes.flexCenter, classes.time)}
                component="div"
              >
                {/*<AccessTimeOutlined className={classes.iconDate} /> 1h*/}
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography className={classes.flexCenter} component="div">
                <DateRangeOutlined className={classes.iconDate} />
                <span style={{ color: grey["500"] }}>Fin:</span> &nbsp;{" "}
                <strong>
                  {Array.isArray(project.medical_visits) && project.medical_visits.length > 1 &&
                    project.medical_visits[1].date}
                </strong>
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                className={classNames(classes.flexCenter, classes.time)}
                component="div"
              >
                {/*<AccessTimeOutlined className={classes.iconDate} /> 2h*/}
              </Typography>
            </Grid>
          </Grid>
        </div>

        <Divider />

        {/*<div className={classes.container}>*/}
        {/*  <Grid container spacing={8}>*/}
        {/*    <Grid item xs={12}>*/}
        {/*      <Typography*/}
        {/*        className={classNames(classes.flexCenter, classes.time)}*/}
        {/*        component="div"*/}
        {/*        color="textPrimary"*/}
        {/*      >*/}
        {/*        <AccountBalanceWalletOutlined className={classes.iconDate} />*/}
        {/*        <span style={{ color: grey["500"] }}>Retribucion:</span>&nbsp;*/}
        {/*        <strong>45 CC</strong>*/}
        {/*      </Typography>*/}
        {/*    </Grid>*/}
        {/*  </Grid>*/}
        {/*</div>*/}
      </div>
    );
  }
}

ItemSummary.propTypes = {
  showStudyNumber: PropTypes.bool.isRequired,
  showHelpButton: PropTypes.bool.isRequired
};

export default withStyles(styles)(ItemSummary);



// WEBPACK FOOTER //
// ./src/modules/test/components/ItemDetail/ItemSummary.js